import { withStyles } from '@material-ui/core/styles';
import Pause from '@material-ui/icons/Pause';
import IconButton from '@material-ui/core/IconButton';
import React from 'react';
import ReactHowler from 'react-howler';
import { Grid } from '@material-ui/core';
import { styles } from './styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

class AudioPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playing: false,
      loaded: false,
      mute: false,
      volume: 1.0
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.handleOnEnd = this.handleOnEnd.bind(this);
    this.handleOnPlay = this.handleOnPlay.bind(this);
    this.handleStop = this.handleStop.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  handleToggle() {
    this.setState({
      playing: !this.state.playing
    });
  }
  handleOnPlay() {
    this.setState({
      playing: true
    });
  }
  handleOnEnd() {
    this.setState({
      playing: false
    });
  }
  handleStop() {
    this.player.stop();
    this.setState({
      playing: false
    });
  }
  onKeyDown = event => {
    switch (event.keyCode) {
      case 32:
        if (this.state.playing === true) {
          this.setState({
            playing: false
          });
        } else {
          this.setState({
            playing: true
          });
        }
        break;
      case 80:
        if (this.state.playing === true) {
          this.setState({
            playing: false
          });
        } else {
          this.setState({
            playing: true
          });
        }
        break;
      default:
    }
    return false;
  };

  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown);
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <div className={classes.player}>
          <ReactHowler
            src={this.props.audioURL}
            playing={this.state.playing}
            onLoad={this.handleOnLoad}
            onPlay={this.handleOnPlay}
            onEnd={this.handleOnEnd}
            volume={this.state.volume}
            ref={ref => (this.player = ref)}
          />
          <Grid container className={classes.controls}>
            <Grid item xs={8} className={classes.instructions}>
              CLIQUER SUR LECTURE POUR LANCER LA NARRATION
            </Grid>
            <Grid item xs={2}>
              <ArrowForwardIcon alt='Arrow' className={classes.arrow} />
            </Grid>
            {this.state.playing === true ? (
              <Grid item xs={2} className={classes.pauseDiv}>
                <IconButton>
                  <Pause className={classes.pauseButton} onClick={this.handleToggle} />
                </IconButton>
              </Grid>
            ) : (
              <Grid item xs={2} className={classes.micDiv}>
                <IconButton>
                  <img
                    alt='Microphone'
                    src={require('../../assets/images/mic.png')}
                    onClick={this.handleToggle}
                    className={classes.mic}
                  />
                </IconButton>
              </Grid>
            )}
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(AudioPlayer);
